import type { FC } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

/**
 * Only meant for our checkbox component!
 */
export const CheckboxUnchecked: FC<SvgIconProps> = (props) => (
  <SvgIcon width="20" height="20" {...props}>
    <path
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21 1H3C1.89543 1 1 1.89543 1 3V21C1 22.1046 1.89543 23 3 23H21C22.1046 23 23 22.1046 23 21V3C23 1.89543 22.1046 1 21 1ZM3 0C1.34315 0 0 1.34315 0 3V21C0 22.6569 1.34315 24 3 24H21C22.6569 24 24 22.6569 24 21V3C24 1.34315 22.6569 0 21 0H3Z"
      fill="currentColor"
    />
  </SvgIcon>
)
